import React, { Component } from 'react';
import Layout from './Layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSadTear } from '@fortawesome/free-solid-svg-icons';

export default class NotFound extends Component {

  render() {
    return (
      <Layout>
        <div className="m-5 text-center">
          <FontAwesomeIcon color="#18a199" size="7x" icon={faSadTear} />
          <p className="m-2">404</p>
          <p className="m-2">Tokio puslapio nėra</p>
        </div>
      </Layout>
    );
  }
}
